import React from "react";

export declare interface Props {
  children: React.ReactNode;
}

export function CenteredContainer({ children }: Props) {
  return (
    <div className="vh-100 d-flex align-items-center justify-content-center">
      {children}
    </div>
  );
}
